












































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import CaseFormRecordType from '@/modules/Case/components/forms/CaseFormRecordType.vue'
import CaseFormAccount from '@/modules/Case/components/forms/CaseFormAccount.vue'
import CaseFormInfo from '@/modules/Case/components/forms/CaseFormInfo.vue'
import CaseFormSource from '@/modules/Case/components/forms/CaseFormSource.vue'
import CaseFormType from '@/modules/Case/components/forms/CaseFormType.vue'
import CaseFormPolicy from '@/modules/Case/components/forms/CaseFormPolicy.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import RecordTypesHandler from '@/mixins/record-types'
import { newCase, editCaseById } from '@/modules/Case/gql/case.gql'
import { ICaseRecordTypeInput, ICasePolicyInput, ICaseAccountInput, ICaseInfoInput, ICaseSourceInput, ICaseTypeInput } from '@/modules/Case/interfaces/case-form'
import { caseTypeKeys, casePriorityKeys, caseTypeValues } from '@/modules/Case/helpers/case'
import { Case } from '@/modules/Case/interfaces/case'
import { Account } from '@/modules/Account/interfaces/account'

@Component({
  components: {
    CaseFormType,
    CaseFormRecordType,
    CaseFormAccount,
    CaseFormInfo,
    AppDialog,
    CaseFormSource,
    AppSteps,
    CaseFormPolicy
  }
})
export default class CaseForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Object as () => Account }) readonly account!: Account

  showDialog = false
  loading = false

  recordTypeIndex = 0
  stepIndex = 0
  normalSteps = [
    ['Case Type', 680, 301],
    ['Record Type', 680, 561],
    ['Account Info', 770, 301],
    ['Case Info', 770, 471],
    ['Source Info', 770, 301]
  ]

  policySteps = [
    ['Case Type', 680, 301],
    ['Choose Policy', 770, 301],
    ['Case Info', 770, 471]
  ]

  caseTypeInput: ICaseTypeInput = {
    caseTypeIdx: 0
  }

  recordTypeInput: ICaseRecordTypeInput = {
    recordType: {}
  }

  accountInput: ICaseAccountInput = {
    account: {},
    primaryContact: {}
  }

  infoInput: ICaseInfoInput = {
    inquiryName: '',
    caseManager: {},
    priorityIdx: -1,
    notes: ''
  }

  sourceInput: ICaseSourceInput = {
    source: {}
  }

  policyInput: ICasePolicyInput = {
    policy: {}
  }

  ifNormal = true

  get ifEdit () {
    return !!this.caseInfo
  }

  get steps () {
    return this.ifNormal
      ? this.normalSteps
      : this.policySteps
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.recordTypeInput.recordType.name ? ' (' + this.recordTypeInput.recordType.name + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : this.caseInfo
        ? 'Save'
        : 'Create'
  }

  get confirmAheadText () {
    return this.caseInfo ? 'Save' : 'Create'
  }

  get canPost () {
    return this.stepIndex === 3
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  @Watch('caseTypeInput.caseTypeIdx')
  onCaseTypeChanged (val: number) {
    this.ifNormal = this.$R.contains(val, [0, 6])
  }

  @Watch('stepIndex')
  onStepChanged (val: number) {
    const {
      recordTypeInput: {
        recordType
      },
      accountInput: {
        account
      },
      caseTypeInput: {
        caseTypeIdx
      },
      infoInput: {
        inquiryName
      },
      policyInput: {
        policy
      },
      ifNormal
    } = this

    if ((ifNormal && val !== 3) || (!ifNormal && val !== 2) || inquiryName) {
      return
    }

    const caseType = caseTypeValues[caseTypeIdx]
    const year = this.$moment.tz('America/New_York').year()

    if (this.ifNormal) {
      if (!account.name) {
        return
      }

      this.infoInput.inquiryName = `${account.name}-${recordType.name}-Case-${caseType}-${year}`
    } else {
      if (!policy.account || !policy.recordType) {
        return
      }

      this.infoInput.inquiryName = `${policy.account.name}-${policy.recordType.name}-Case-${caseType}-${year}`
    }
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.caseInfo) {
      const {
        type, inquiryName, caseNote, priority,
        caseManager, recordType, account, primaryContact, source, targetPolicy
      } = this.caseInfo
      const caseTypeIdx = caseTypeKeys.findIndex(key => key === type)
      this.onCaseTypeChanged(caseTypeIdx)

      this.caseTypeInput = {
        caseTypeIdx
      }
      this.recordTypeInput = {
        recordType: {
          id: +recordType.id,
          name: recordType.name
        }
      }
      this.accountInput = {
        account: {
          id: +account.id,
          name: account.name
        },
        primaryContact: {
          id: primaryContact ? +primaryContact.id : undefined,
          name: primaryContact ? primaryContact.name : ''
        }
      }
      this.infoInput = {
        inquiryName,
        priorityIdx: casePriorityKeys.findIndex(key => key === priority),
        caseManager: {
          id: caseManager ? +caseManager.id : undefined,
          name: caseManager ? caseManager.username : ''
        },
        notes: caseNote
      }
      this.sourceInput = {
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }
      this.policyInput = {
        policy: {
          id: targetPolicy ? +targetPolicy.id : undefined,
          name: targetPolicy ? targetPolicy.policyName : ''
        }
      }
    } else {
      this.clearForm()
    }

    if (this.account) {
      const { id, name, source } = this.account

      this.accountInput = {
        ...this.accountInput,
        account: {
          id: +id,
          name
        }
      }
      this.sourceInput = {
        ...this.sourceInput,
        source: {
          id: source ? +source.id : undefined,
          name: source ? source.name : ''
        }
      }
    }
  }

  policyHandler (policy: Policy) {
    this.recordTypeInput.recordType = {
      id: +policy.recordType.id,
      name: policy.recordType.name
    }
  }

  handleStepClick (index: number) {
    if (!this.caseInfo) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      if (this.caseInfo) {
        this.handleUpdate()
      } else {
        this.handleCreate()
      }
    } else {
      this.stepIndex += 1
    }
  }

  initSource (account: Account) {
    const { sourceInput } = this

    if (sourceInput.source && sourceInput.source.id) {
      return
    }
    if (account.source) {
      this.sourceInput.source = {
        id: +account.source.id,
        name: account.source.name
      }
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    }
  }

  async handleCreate () {
    const {
      caseTypeInput: { caseTypeIdx },
      recordTypeInput: { recordType: { id: recordTypeId } },
      accountInput: {
        account: { id: accountId },
        primaryContact: { id: primaryContactId }
      },
      infoInput: {
        inquiryName,
        priorityIdx,
        caseManager: { id: caseManagerId },
        notes
      },
      sourceInput: {
        source: { id: sourceId }
      },
      policyInput: {
        policy: { id: targetPolicyId }
      }
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newCase,
        variables: {
          caseInput: {
            inquiryName: inquiryName,
            type: caseTypeKeys[caseTypeIdx],
            recordTypeId,
            accountId,
            primaryContactId,
            caseManagerId,
            caseNote: notes,
            sourceId,
            targetPolicyId,
            priority: priorityIdx === -1
              ? null
              : +casePriorityKeys[priorityIdx]
          }
        }
      })
      this.clearForm()
      this.onSuccess('Create the new case successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  async handleUpdate () {
    const {
      caseTypeInput: { caseTypeIdx },
      recordTypeInput: { recordType: { id: recordTypeId } },
      accountInput: {
        account: { id: accountId },
        primaryContact: { id: primaryContactId }
      },
      infoInput: {
        inquiryName,
        priorityIdx,
        caseManager: { id: caseManagerId },
        notes
      },
      sourceInput: {
        source: { id: sourceId }
      },
      policyInput: {
        policy: { id: targetPolicyId }
      }
    } = this
    try {
      const res = await this.$apollo.mutate({
        mutation: editCaseById,
        variables: {
          caseId: +this.caseInfo.id,
          caseInput: {
            inquiryName: inquiryName,
            type: caseTypeKeys[caseTypeIdx],
            recordTypeId,
            accountId,
            primaryContactId,
            caseManagerId,
            caseNote: notes,
            sourceId,
            targetPolicyId,
            priority: priorityIdx === -1
              ? null
              : +casePriorityKeys[priorityIdx]
          }
        }
      })
      this.onSuccess('Update case successfully')
      this.clearForm()
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  clearForm () {
    this.loading = false
    this.caseTypeInput = {
      caseTypeIdx: 0
    }
    this.recordTypeInput = {
      recordType: {}
    }
    this.accountInput = {
      account: {},
      primaryContact: {}
    }

    this.infoInput = {
      inquiryName: '',
      caseManager: {},
      priorityIdx: -1,
      notes: ''
    }

    this.sourceInput = {
      source: {}
    }

    this.policyInput = {
      policy: {}
    }
  }

  @Emit('hide')
  handleHide () {
    this.$emit('input', false)
  }

  @Emit('cancel')
  handleCancel () {
    this.handleHide()
    this.clearForm()
  }

  @Emit('success')
  @Emit('hide')
  onSuccess (msg = '') {
    this.handleHide()
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
